type SearchResultImage = {
	url: string;
	height: number;
	width: number;
};
export type SearchResult = {
	id: string;
	slug: string;
	item_type: string;
	title: string;
	preview_text: string;
	preview_image?: null | SearchResultImage;
	// modules: unknown[];
};

export type ArtistSearchResult = SearchResult & {
	start_time?: null | string;
	location?: null | string;
	images: SearchResultImage[];
	show_time: boolean;
	content_type?: null | {
		id: string;
		name: string;
	};
};

export type ContentSearchResult = SearchResult & {
	parent_page?: null | string;
	subtitle: string;
	image?: null | SearchResultImage;
};

export type SearchResultsArray = (ArtistSearchResult | ContentSearchResult)[];
export type GroupedSearchResults = {
	label: string;
	items: SearchResultsArray;
}[];

const labelMap: { [key: string]: string } = {
	artist_page: 'Program',
	content_page: 'Information',
};

export const groupByType = (items: SearchResultsArray) => {
	return items.reduce<GroupedSearchResults>((acc, item) => {
		const itemType = labelMap[item.item_type] ?? 'Andet';
		const groupIndex = acc.findIndex(group => group.label === itemType);
		if (groupIndex === -1) {
			acc.push({ label: itemType, items: [item] });
		} else {
			acc[groupIndex].items.push(item);
		}
		return acc;
	}, []);
};

export const isArtistResult = (item: SearchResult): item is ArtistSearchResult => {
	return item.item_type === 'artist_page';
};

export const isContentResult = (item: SearchResult): item is ContentSearchResult => {
	return item.item_type === 'content_page';
};
